export default {
	reserve: {
		trv_fec_dev: null,
		trv_num_res: null, 
		trv_cod_cnd: null, 
		ter_cod_est: null, 
		trv_chk_tyc: null,
		trv_chk_dtv: null
	},
	client: {
		tmc_cod_cli: null,
		tmc_rut_psp: null,
		tmc_dig_rut: null,
		tmc_nom_cli: null,
		tmc_fec_nac: null,
		tmc_fec_lic: null,
		ttc_val_eml: null,
		tcc_cod_ctc: null,
		ttc_val_tel: null,
		tdc_cod_dir: null,
		tdc_dir_cli: null,
		tdc_cod_com: null,
		tmc_des_com: null,
		tac_ven_ced: null,
		tac_ven_lic: null,
		tac_ced_adl: null,
		tac_ced_trs: null,
		tac_lic_adl: null,
		tac_lic_trs: null
	},
	vehicle: {},
};